import React from 'react';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import { EngagementName } from '../components/workflow/CoverageDisplay';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import useWorkflowPerms from '../components/workflow/useWorkflowPerms';

// CaseWare, Charge Code & Team Update — list page (docs/modules/workflow-cwcc.md).
// Request CaseWare access, a charge code and/or a team member update for an
// existing engagement; a review-key holder approves, then QM completes each
// item.
const WorkflowCwcc = () => {
  const { canSubmit } = useWorkflowPerms('cwcc');
  return (
    <WorkflowListShell
      title="CaseWare, Charge Code & Team Update"
      subtitle="CaseWare access, charge code and team update requests."
      newTo="/workflow/cwcc/new"
      canCreate={canSubmit}
      apiPath="/api/workflow/cwcc"
      rowTo={(r) => `/workflow/cwcc/${r.id}`}
      searchPlaceholder="Search request no, engagement or requester…"
      defaultSort={{ key: 'createdAt', direction: 'desc' }}
      columns={[
        { key: 'requestNo', label: 'Request', sortKey: 'requestNo', render: (r) => <span className="font-medium text-blue-700">{r.requestNo}</span> },
        {
          key: 'engagementName',
          label: 'Engagement',
          sortKey: 'engagementName',
          // 一張單可涵蓋多案——清單顯示第一案＋「+N」。
          render: (r) => (
            <>
              <EngagementName name={r.engagementName} serviceDescription={r.serviceDescription} />
              {(r.engagementCount || 1) > 1 && (
                <span className="ml-1 text-xs text-slate-500">+{r.engagementCount - 1} more</span>
              )}
            </>
          ),
        },
        { key: 'cwStatus', label: 'CaseWare', sortKey: 'cwStatus', render: (r) => <WorkflowStatusBadge status={r.cwStatus} /> },
        { key: 'ccStatus', label: 'Charge Code', sortKey: 'ccStatus', render: (r) => <WorkflowStatusBadge status={r.ccStatus} /> },
        { key: 'memberStatus', label: 'Team Update', render: (r) => <WorkflowStatusBadge status={r.memberStatus || 'na'} /> },
        { key: 'requester', label: 'Requested By', render: (r) => <span className="text-slate-500">{r.requesterEmail}</span> },
      ]}
    />
  );
};

export default WorkflowCwcc;
